import { render } from "./ListReport.vue?vue&type=template&id=15f05628&scoped=true"
import script from "./ListReport.vue?vue&type=script&lang=js"
export * from "./ListReport.vue?vue&type=script&lang=js"

import "./ListReport.vue?vue&type=style&index=0&id=15f05628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f05628"]])

export default __exports__